import { FC } from 'react'
import { JoinMailingDecision } from '.'
import {
  StepCommonProps,
  JoinLayout,
  withOpenAccountCaptureDefaults,
} from '../OpenAccountPage'
import { useOnboardingSteps } from '@/context/OnboardingStepContext/OnboardingStepContext'

export const JoinMailingDecisionStep: FC<StepCommonProps> = ({
  setFormData,
}) => {
  const { goForward } = useOnboardingSteps()
  return (
    <JoinLayout title="Before you download, let's keep in touch">
      <JoinMailingDecision
        onSubmit={isJoiningMailingList => {
          setFormData(prev => ({
            ...withOpenAccountCaptureDefaults(prev),
            isJoiningMailingList,
          }))
          goForward()
        }}
      />
    </JoinLayout>
  )
}
